/**
 * `#uc2Indicators` — the four things UC2 reads, in plain words (NOTES #729's UC1 lesson,
 * applied here): what each one is and the years it covers. No numbers, no datasets block —
 * a watershed clicked on the map carries the numbers in `#uc2Card` underneath.
 */
import { useTranslation } from 'react-i18next';

/** The four lines, in the order the method itself runs (client §4's sentences 1–5). */
export const UC2_INDICATORS = ['landcover', 'rainfall', 'practices', 'similar'] as const;

export function Uc2Indicators() {
  const { t } = useTranslation();
  return (
    <div id="uc2Indicators" className="result-box">
      <h5>{t('intel.uc2.indicators.title')}</h5>
      <div className="result-pad">
        <ul className="uc1-essence">
          {UC2_INDICATORS.map((id) => (
            <li key={id} data-testid={`uc2-indicator-${id}`}>
              <b>{t(`intel.uc2.indicators.${id}.title`)}</b>
              <span>{t(`intel.uc2.indicators.${id}.what`)}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Uc2Indicators;
